module.exports = __webpack_public_path__ + "static/img/xiaochengxu_title.2f5963c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/xiaochengxu_title.png
// module id = SpuN
// module chunks = 0